export type ClickTargetInfo = { target: string; label?: string };

const INTERACTIVE_SELECTOR = 'button, a, [role="button"], input, select, textarea, label';

function buildTarget(el: Element): string {
  const tag = el.tagName.toLowerCase();
  const id = el.id ? `#${el.id}` : '';
  const classes = Array.from(el.classList)
    .slice(0, 2)
    .map((c) => `.${c}`)
    .join('');
  return `${tag}${id}${classes}`;
}

function maskPII(value: string): string {
  return value
    .replace(/\S+@\S+\.\S+/g, '[email]')
    .replace(/\d{4,}/g, '####')
    .trim();
}

function readText(el: Element): string {
  const parts: string[] = [];
  const walker = el.ownerDocument.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    const part = node.textContent?.replace(/\s+/g, ' ').trim();
    if (part) parts.push(part);
  }
  return parts.join(' ').slice(0, 32);
}

function resolveLabel(el: Element): string | undefined {
  const ariaLabel = el.getAttribute('aria-label');
  const title = el.getAttribute('title');
  const text = readText(el);

  const raw = ariaLabel || title || text;
  if (!raw) return undefined;

  const masked = maskPII(raw);
  return masked || undefined;
}

export function describeClickTarget(node: EventTarget | null): ClickTargetInfo | null {
  if (!(node instanceof Element)) return null;

  const el = node.closest(INTERACTIVE_SELECTOR) ?? node;

  const target = buildTarget(el);
  const label = resolveLabel(el);

  return label ? { target, label } : { target };
}
